(function ($) {
    $.fn.formData = function (values) {
        "use strict";
        var form = $(this);
        var inputs = $(':input', form).get();

        $.each(inputs, function () {
            var input = $(this);
            var value = values[this.name];

            if (values.hasOwnProperty(this.name)) {
                switch (this.type) {
                    //case 'checkbox':
                    //    input.prop('checked', value !== null && value);
                    //    break;
                    case 'radio':
                    case 'checkbox':
                        if (value === null) {
                            input.prop('checked', false);
                        } else if ($.isArray(value)) {
                            if ($.inArray(input.val(), value) >= 0) {
                                input.prop("checked", true);
                            }
                        } else if (input.val() == value) {
                            input.prop("checked", true);
                        }
                        break;
                    default:
                        input.val(value);
                }
            }
        });
        return form;
    }
})(jQuery);